// extracted by mini-css-extract-plugin
export default {"container":"styles_container__OCeIQ","input":"styles_input__nOhxO","smallInput":"styles_smallInput__DqdsW","separator":"styles_separator__SlzNA"};